import React, { useState } from 'react';
import Sidebar from "./Sidebar";
import TopNavbar from "../top-navbar/TopNav";
import '../../styles/employee/UanCheck.css';
import PropTypes from 'prop-types';
import { getDecryptedToken } from '../decryptToken';
import { ENCRYPTED_SUREPASS_TOKEN } from '../../encryptedToken';
import Loader from '../loader/Loader';
import { toast } from 'react-toastify';
import { employmentCheckUAN } from '../../services/employee/api';

const UanCheck = ({ candidateId, onBack }) => {
    const surepassToken = getDecryptedToken(ENCRYPTED_SUREPASS_TOKEN);

    const [uan, setUan] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [employmentData, setEmploymentData] = useState([]);
    const [isVerified, setIsVerified] = useState(false); 
    const [submitMessage, setSubmitMessage] = useState('');

    const fetchDetails = async () => {
        setError('');
        setEmploymentData([]);
        setSubmitMessage('');

        if (!/^\d{12}$/.test(uan)) {
            setError('UAN must be exactly 12 digits.');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch('https://kyc-api.surepass.app/api/v1/income/employment-history-uan-v2', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc1MTA4NzkxNywianRpIjoiOTk0MWMzMGUtNGY4Ny00NTNkLWE0OTEtODNkNmZiNDE0OGEzIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LnVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsIm5iZiI6MTc1MTA4NzkxNywiZXhwIjoyMzgxODA3OTE3LCJlbWFpbCI6InVzZXJuYW1lXzJ4czhtMzRoZDZ1ZHFheWh2aG9uYzQxdmhzeEBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.HJHPVrHRTVD0wwXiiI226F7A7r_fIAjMvVaChKoc6W8`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id_number: uan })
            });

            const data = await response.json();

            if (data.success && data.data && Array.isArray(data.data.employment_history)) {
                const mapped = data.data.employment_history.map(emp => ({
                    uan: data.data.uan || 'N/A',
                    name: emp.name || 'N/A',
                    memberId: emp.member_id || 'N/A',
                    dojEpf: emp.date_of_joining || 'N/A',
                    doeEpf: emp.date_of_exit || 'N/A',
                    lastPFSubmittedDate: emp.last_pf_submitted || 'N/A',
                    monthHistory: emp.wage_month || 'N/A', // not provided by API
                    companyName: emp.establishment_name || 'N/A',
                    // companyAddress: 'N/A', // not provided by API
                    // leaveReason: 'N/A' // not provided by API
                }));
                setEmploymentData(mapped);
            } else {
                setError(data.message || 'No records found for this UAN.');
            }
/*
             const dummyData = [
                {
                    uan: uan,
                    name: "John Doe",
                    memberId: "MH/BAN/1234567",
                    dojEpf: "2020-01-15",
                    doeEpf: "2023-03-10",
                    lastPFSubmittedDate: "2023-02-28",
                    monthHistory: "Jan 2020: Active",
                    companyName: "Dummy Pvt Ltd"
                },
                {
                    uan: uan,
                    name: "Jane Smith",
                    memberId: "MH/BAN/7654321",
                    dojEpf: "2019-05-20",
                    doeEpf: "2022-11-01",
                    lastPFSubmittedDate: "2022-10-30",
                    monthHistory: "Jan 2022: Active",
                    companyName: "Tech Corp"
                }
            ];

            setEmploymentData(dummyData);
            */
        } catch (err) {
            console.error("API Error:", err);
            setError("API Error. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleVerificationCheckboxChange = (e) => {
        setIsVerified(e.target.checked);
    };

    const handleSubmit = async () => {
        setSubmitMessage('');
        if (employmentData.length === 0) {
            toast.error('Please fetch valid UAN details.');
            return;
        }

        // if (!isVerified) {
        //     toast.error('Please check Verification Status before submitting.');
        //     return;
        // }

        const token = localStorage.getItem('bgc_token');
        if (!token) {
            setSubmitMessage('Authentication token not found. Please log in.');
            return;
        }

        const uanRequestList = employmentData.map(item => ({
            candidateId: candidateId,
            uan: item.uan,
            name: item.name,
            memberId: item.memberId,
            dojEpf: item.dojEpf,
            doeEpf: item.doeEpf,
            monthHistory: item.monthHistory,
            companyName: item.companyName,
            companyAddress: item.companyAddress,
            leaveReason: item.leaveReason,
            lastPFSubmittedDate: item.lastPFSubmittedDate,
            isVerified: isVerified
        }));

        try {
            const response = await employmentCheckUAN(
                candidateId,
                isVerified,
                uanRequestList
            );
                toast.success("UAN Employment Check data saved successfully", {
                    autoClose: 3000,
                });

               onBack();
            } catch (error) {
                const errorMessage =
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to save UAN details.";

                toast.error(errorMessage);
            }
    };

    return (
        <div className="uan-dashboard-app-container">
            {loading && <Loader />}
            <Sidebar />
            <div className="uan-dashboard-right-panel">
                <TopNavbar />
                <div className="uan-check-container">
                    <div className="uan-card">
                        <div className="uan-card-header">
                            <h2>UAN Check</h2>
                        </div>
                        <div className="uan-card-body">
                            <div className="uan-form-group">
                                <label htmlFor="uanNumber">UAN Number</label>
                                <input
                                    type="text"
                                    id="uanNumber"
                                    className="uan-form-control"
                                    placeholder="Enter UAN Number"
                                    value={uan}
                                    onChange={(e) => setUan(e.target.value)}
                                />
                                {error && <div className="uan-error-message">{error}</div>}
                            </div>
                            <button className="uan-fetch-button" onClick={fetchDetails} disabled={loading}>
                                {loading ? 'Fetching...' : 'Fetch Details'}
                            </button>
                        </div>
                    </div>

                    <div className="uan-card uan-employment-records-card">
                        <div className="uan-card-header">
                            <h2>Employment Records</h2>
                        </div>
                        <div className="uan-card-body">
                            <div className="uan-table-responsive">
                                <table className="uan-employment-table">
                                    <thead>
                                        <tr>
                                            <th>UAN</th>
                                            <th>Name</th>
                                            <th>Member ID</th>
                                            <th>DOJ_Epf</th>
                                            <th>DOE_Epf</th>
                                            <th>Last PF Submitted</th>
                                            <th>Last Contribution</th>
                                            <th>Company Name</th>
                                            {/* <th>Company Address</th>
                                            <th>Leave Reason</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading && (
                                            <tr>
                                                <td colSpan="9" className="uan-text-center">Loading...</td>
                                            </tr>
                                        )}
                                        {!loading && employmentData.length > 0 ? (
                                            employmentData.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data.uan}</td>
                                                    <td>{data.name}</td>
                                                    <td>{data.memberId}</td>
                                                    <td>{data.dojEpf}</td>
                                                    <td>{data.doeEpf}</td>
                                                    <td>{data.lastPFSubmittedDate}</td>
                                                    <td>{data.monthHistory}</td>
                                                    <td>{data.companyName}</td>
                                                    {/* <td>{data.companyAddress}</td>
                                                    <td>{data.leaveReason}</td> */}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9" className="uan-text-center uan-no-records">
                                                    No records found. Please fetch valid UAN.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* <div className="uan-verification-section">
                        <label className="uan-verification-label">
                           <input
                                type="checkbox"
                                className="uan-verification-checkbox"
                                onChange={handleVerificationCheckboxChange}
                                checked={isVerified}
                            />
                            <span>Verification Status</span>
                           
                        </label>
                    </div> */}

                    {submitMessage && (
                        <div className={`uan-submit-message ${submitMessage.includes('successfully') ? 'uan-success-message' : 'uan-error-message'}`}>
                            {submitMessage}
                        </div>
                    )}

                    <div className="uan-action-buttons">
                        <button className="uan-cancel-button" onClick={onBack}>Cancel</button>
                        <button className="uan-submit-button" onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

UanCheck.propTypes = {
    candidateId: PropTypes.string.isRequired,
    onBack: PropTypes.func.isRequired,
};

export default UanCheck;